import React from 'react';
import ChatInterface from './ChatInterface';
import '../../styles/main.scss';

const PBConversion = () => {
    return (
        <div className="ibeam-container" style={{ padding: '16px', position: 'relative' }}>
            {/* Main Chat Interface */}
            <ChatInterface />
        </div>
    );
};

export default PBConversion;
